import React from 'react';
import TaskListItem from '../task-list-item/TaskListItem'
import { Checkbox } from 'material-ui';
import './task-list.scss'

const TaskList = ({tasks}) => {
    return (
        <div className='task-list'>
            <div className="group-head">
                <p>@clientname @date</p>
                <Checkbox 
                    className="task-checkbox"
                />
            </div>
            {
                tasks.map((task, i) => <TaskListItem name={task.name} date={task.date} key={i}/>)
            }
        </div>
    );
};

export default TaskList;